module.exports = __webpack_public_path__ + "img/image@2x.b17b1f82.webp";